import { Link } from "react-router-dom";
import { ArrowRight, Check, Phone } from "lucide-react";
import Seo from "../components/Seo";
import { CTA } from "../components/CTA";
import { BUSINESS } from "../lib/site";

export default function CategoryPage({ cat }) {
  return (
    <div data-testid={`category-page-${cat.category.replace(/[^a-z0-9]+/gi, "-").toLowerCase()}`}>
      <Seo title={cat.seoTitle} description={cat.seoDesc} />

      <section className="relative overflow-hidden">
        <img
          src={cat.image}
          alt={cat.title}
          className="absolute inset-0 h-full w-full object-cover"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-ves-black via-ves-black/90 to-ves-black/50" />
        <div className="relative mx-auto max-w-7xl px-4 py-20 sm:px-6 sm:py-28 lg:px-8">
          <p className="font-heading text-xs font-bold tracking-[0.25em] text-ves-green">
            {cat.eyebrow}
          </p>
          <h1 className="mt-3 max-w-3xl font-heading text-4xl font-black text-white sm:text-5xl">
            {cat.title}
          </h1>
          <div className="mt-6 flex flex-col gap-3 sm:flex-row">
            <Link
              to={`/sell-your-surplus?category=${encodeURIComponent(cat.category)}`}
              className="bg-ves-green px-7 py-4 text-center font-heading text-base font-black tracking-wide text-ves-black transition-colors duration-150 hover:bg-white"
              data-testid="category-get-offer-btn"
            >
              SELL THIS EQUIPMENT <ArrowRight className="inline h-5 w-5" />
            </Link>
            <a
              href={BUSINESS.phoneTel}
              className="border-2 border-ves-green px-7 py-4 text-center font-heading text-base font-black tracking-wide text-ves-green transition-colors duration-150 hover:bg-ves-green hover:text-ves-black"
              data-testid="category-call-btn"
            >
              <Phone className="inline h-5 w-5" /> CALL {BUSINESS.phoneDisplay}
            </a>
          </div>
        </div>
      </section>

      <section className="bg-ves-black py-16 sm:py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl space-y-4">
            {cat.intro.map((p, i) => (
              <p key={i} className="text-base leading-relaxed text-white/75 sm:text-lg">
                {p}
              </p>
            ))}
          </div>

          <div className={`mt-12 grid gap-8 ${cat.groups.length > 1 ? "lg:grid-cols-2" : ""}`}>
            {cat.groups.map((g) => (
              <div key={g.heading} className="border border-white/10 bg-ves-charcoal/50 p-6 sm:p-8">
                <h2 className="font-heading text-xl font-black text-white">{g.heading}</h2>
                <ul className="mt-5 grid gap-2.5 sm:grid-cols-2">
                  {g.items.map((item) => (
                    <li key={item} className="flex items-start gap-2.5 text-sm text-white/75">
                      <Check className="mt-0.5 h-4 w-4 shrink-0 text-ves-green" />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {cat.note && (
            <div className="mt-10 border-l-4 border-ves-green bg-ves-forest/50 p-6 sm:p-8" data-testid="category-note">
              <h2 className="font-heading text-lg font-black tracking-wide text-white">
                {cat.note.heading}
              </h2>
              <p className="mt-2 text-sm leading-relaxed text-white/80">{cat.note.text}</p>
            </div>
          )}
        </div>
      </section>

      <CTA />
    </div>
  );
}
